// extracted by mini-css-extract-plugin
module.exports = {"invitation":"_5D3S9ut8","loader":"_5DZ6r01G"};